webpackJsonp([12],{

/***/ 193:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(477)
}
var Component = __webpack_require__(203)(
  /* script */
  __webpack_require__(479),
  /* template */
  __webpack_require__(482),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-cf7f3b7a",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 203:
/***/ (function(module, exports) {

/* globals __VUE_SSR_CONTEXT__ */

// this module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle

module.exports = function normalizeComponent (
  rawScriptExports,
  compiledTemplate,
  injectStyles,
  scopeId,
  moduleIdentifier /* server only */
) {
  var esModule
  var scriptExports = rawScriptExports = rawScriptExports || {}

  // ES6 modules interop
  var type = typeof rawScriptExports.default
  if (type === 'object' || type === 'function') {
    esModule = rawScriptExports
    scriptExports = rawScriptExports.default
  }

  // Vue.extend constructor export interop
  var options = typeof scriptExports === 'function'
    ? scriptExports.options
    : scriptExports

  // render functions
  if (compiledTemplate) {
    options.render = compiledTemplate.render
    options.staticRenderFns = compiledTemplate.staticRenderFns
  }

  // scopedId
  if (scopeId) {
    options._scopeId = scopeId
  }

  var hook
  if (moduleIdentifier) { // server build
    hook = function (context) {
      // 2.3 injection
      context =
        context || // cached call
        (this.$vnode && this.$vnode.ssrContext) || // stateful
        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
      // 2.2 with runInNewContext: true
      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__
      }
      // inject component styles
      if (injectStyles) {
        injectStyles.call(this, context)
      }
      // register component module identifier for async chunk inferrence
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier)
      }
    }
    // used by ssr in case component is cached and beforeCreate
    // never gets called
    options._ssrRegister = hook
  } else if (injectStyles) {
    hook = injectStyles
  }

  if (hook) {
    var functional = options.functional
    var existing = functional
      ? options.render
      : options.beforeCreate
    if (!functional) {
      // inject component registration as beforeCreate hook
      options.beforeCreate = existing
        ? [].concat(existing, hook)
        : [hook]
    } else {
      // register for functioal component in vue file
      options.render = function renderWithStyleInjection (h, context) {
        hook.call(context)
        return existing(h, context)
      }
    }
  }

  return {
    esModule: esModule,
    exports: scriptExports,
    options: options
  }
}


/***/ }),

/***/ 204:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(216)
}
var Component = __webpack_require__(203)(
  /* script */
  __webpack_require__(218),
  /* template */
  __webpack_require__(219),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 212:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ("data:image/svg+xml;base64,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");

/***/ }),

/***/ 216:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(217);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(177)("f5ffd5f0", content, true, {});

/***/ }),

/***/ 217:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(176)(true);
// imports


// module
exports.push([module.i, "\n.VideoPlayer iframe {\n  width: 100%;\n  max-height: 600px;\n  max-width: 800px;\n  /* height: 100%; */\n}\n", "", {"version":3,"sources":["/__w/lang_app_eng/lang_app_eng/src/components/Shared/VideoPlayer.vue"],"names":[],"mappings":";AACA;EACE,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;CACpB","file":"VideoPlayer.vue","sourcesContent":["\n.VideoPlayer iframe {\n  width: 100%;\n  max-height: 600px;\n  max-width: 800px;\n  /* height: 100%; */\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 218:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    vidSrc: {
      default: ""
    }
  },
  data: function data() {
    return {
      height: "250px"
    };
  },
  mounted: function mounted() {
    // setTimeout(() => {
    //   this.height = (this.$refs.videoIframe.clientWidth / 16) * 9 + "px";
    //   console.log(this.height);
    // }, 2000);
  }
});

/***/ }),

/***/ 219:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "VideoPlayer"
  }, [_c('iframe', {
    ref: "videoIframe",
    attrs: {
      "src": _vm.vidSrc,
      "height": _vm.height,
      "frameborder": "0",
      "allow": "accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture",
      "allowfullscreen": ""
    }
  })])
},staticRenderFns: []}

/***/ }),

/***/ 241:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return authService; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__userService__ = __webpack_require__(46);



// Get access token
var getToken = function () {
  var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(googleCode) {
    var res, accessToken, _refreshToken, user;

    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            _context.next = 3;
            return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post(apiUrl + "/api-token-auth/", {
              access_token: googleCode
            });

          case 3:
            res = _context.sent;

            if (!(res && res.data)) {
              _context.next = 16;
              break;
            }

            console.log("USER IS LOGGED");
            accessToken = res.data.access_token;
            _refreshToken = res.data.refresh_token;

            if (!accessToken) {
              _context.next = 14;
              break;
            }

            console.log("added acc token to headers");
            __WEBPACK_IMPORTED_MODULE_2_axios___default.a.defaults.headers.common["Authorization"] = "Bearer " + accessToken;
            _context.next = 13;
            return __WEBPACK_IMPORTED_MODULE_3__userService__["a" /* userService */].getUser();

          case 13:
            user = _context.sent;

          case 14:
            if (_refreshToken) window.localStorage.setItem("engrefresh", _refreshToken);
            return _context.abrupt("return", res.data);

          case 16:
            _context.next = 22;
            break;

          case 18:
            _context.prev = 18;
            _context.t0 = _context["catch"](0);

            console.log(_context.t0);
            return _context.abrupt("return", null);

          case 22:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, this, [[0, 18]]);
  }));

  return function getToken(_x) {
    return _ref.apply(this, arguments);
  };
}();

var fixCSRFToken = function () {
  var _ref2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
    var res;
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.prev = 0;

            console.log("Testing CSRF token..");
            // Use a simple health check endpoint instead
            _context2.next = 4;
            return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get(apiUrl + "/health_check");

          case 4:
            res = _context2.sent;
            _context2.next = 10;
            break;

          case 7:
            _context2.prev = 7;
            _context2.t0 = _context2["catch"](0);

            if (_context2.t0.response) {
              if (_context2.t0.response.status == 403) {
                console.log("Token failed.");
                delete_cookie("csrftoken_dev", "/", ".dev.app.morielenglish.co.il");
                delete_cookie("sessionid", "/", ".dev.app.morielenglish.co.il");
              }
            }

          case 10:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, this, [[0, 7]]);
  }));

  return function fixCSRFToken() {
    return _ref2.apply(this, arguments);
  };
}();

// Get token from refresh
var refreshToken = function () {
  var _ref3 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(refreshToken) {
    var res, accessToken, user;
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            _context3.prev = 0;
            _context3.next = 3;
            return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post(apiUrl + "/api-token-refresh/", {
              refresh: refreshToken
            });

          case 3:
            res = _context3.sent;

            if (!(res && res.data)) {
              _context3.next = 12;
              break;
            }

            accessToken = res.data.access;

            if (!accessToken) {
              _context3.next = 11;
              break;
            }

            __WEBPACK_IMPORTED_MODULE_2_axios___default.a.defaults.headers.common["Authorization"] = "Bearer " + accessToken;

            _context3.next = 10;
            return __WEBPACK_IMPORTED_MODULE_3__userService__["a" /* userService */].getUser();

          case 10:
            user = _context3.sent;

          case 11:
            return _context3.abrupt("return", res.data);

          case 12:
            _context3.next = 18;
            break;

          case 14:
            _context3.prev = 14;
            _context3.t0 = _context3["catch"](0);

            console.log(_context3.t0);
            if (_context3.t0.response) {
              if (_context3.t0.response.status == 401 || _context3.t0.response.status == 403) {
                window.localStorage.removeItem("engrefresh");
              }
            }
            // location.reload()

          case 18:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3, this, [[0, 14]]);
  }));

  return function refreshToken(_x2) {
    return _ref3.apply(this, arguments);
  };
}();

// Handle authentication callback with tokens from URL


// Check current authentication state
var checkAuthState = function () {
  var _ref4 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4() {
    var refreshTokenFromStorage, result;
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            refreshTokenFromStorage = window.localStorage.getItem("engrefresh");

            if (!refreshTokenFromStorage) {
              _context4.next = 24;
              break;
            }

            console.log("Auth state: Found refresh token, attempting to refresh access token");
            _context4.prev = 3;
            _context4.next = 6;
            return refreshToken(refreshTokenFromStorage);

          case 6:
            result = _context4.sent;

            if (!(result && result.access)) {
              _context4.next = 12;
              break;
            }

            console.log("Auth state: Successfully refreshed tokens");
            return _context4.abrupt("return", { authenticated: true });

          case 12:
            console.log("Auth state: Failed to refresh tokens");
            window.localStorage.removeItem("engrefresh");
            delete __WEBPACK_IMPORTED_MODULE_2_axios___default.a.defaults.headers.common["Authorization"];
            return _context4.abrupt("return", { authenticated: false });

          case 16:
            _context4.next = 24;
            break;

          case 18:
            _context4.prev = 18;
            _context4.t0 = _context4["catch"](3);

            console.error("Auth state: Error refreshing tokens:", _context4.t0);
            window.localStorage.removeItem("engrefresh");
            delete __WEBPACK_IMPORTED_MODULE_2_axios___default.a.defaults.headers.common["Authorization"];
            return _context4.abrupt("return", { authenticated: false });

          case 24:

            console.log("Auth state: No refresh token found");
            return _context4.abrupt("return", { authenticated: false });

          case 26:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4, this, [[3, 18]]);
  }));

  return function checkAuthState() {
    return _ref4.apply(this, arguments);
  };
}();

var apiUrl = "https://api.dev.app.morielenglish.co.il";
var googleLogin = apiUrl + "/google-direct/";
var googleClientID = "887990840804-eshjuu4g4glg3ufuf6p0ho40c0s1pnrt.apps.googleusercontent.com";

var authService = {
  refreshToken: refreshToken,
  getToken: getToken,
  logout: logout,
  fixCSRFToken: fixCSRFToken,
  googleLogin: googleLogin,
  googleClientID: googleClientID,
  handleAuthCallback: handleAuthCallback,
  checkAuthState: checkAuthState
};




__WEBPACK_IMPORTED_MODULE_2_axios___default.a.defaults.xsrfCookieName = "csrftoken_dev";
__WEBPACK_IMPORTED_MODULE_2_axios___default.a.defaults.xsrfHeaderName = "X-CSRFToken";
__WEBPACK_IMPORTED_MODULE_2_axios___default.a.defaults.withXSRFToken = true;
__WEBPACK_IMPORTED_MODULE_2_axios___default.a.defaults.withCredentials = true;

function logout() {
  var logoutUrl = apiUrl + "/accounts/logout/";
  window.location.href = logoutUrl;
}

function delete_cookie(name, path, domain) {
  if (get_cookie(name)) {
    document.cookie = name + "=" + (path ? ";path=" + path : "") + (domain ? ";domain=" + domain : "") + ";expires=Thu, 01 Jan 1970 00:00:01 GMT";
  }
}

function get_cookie(name) {
  return document.cookie.split(';').some(function (c) {
    return c.trim().startsWith(name + '=');
  });
}function handleAuthCallback() {
  var urlParams = new URLSearchParams(window.location.search);
  var accessToken = urlParams.get('access_token');
  var refreshToken = urlParams.get('refresh_token');
  var error = urlParams.get('error');

  if (error) {
    console.error('Auth callback error:', error);
    // Clear any existing tokens
    window.localStorage.removeItem("engrefresh");
    delete __WEBPACK_IMPORTED_MODULE_2_axios___default.a.defaults.headers.common["Authorization"];
    return { success: false, error: error };
  }

  if (accessToken && refreshToken) {
    console.log("Auth callback: Found tokens in URL");
    console.log("Auth callback: Access token (first 20 chars):", accessToken.substring(0, 20));
    console.log("Auth callback: Refresh token (first 20 chars):", refreshToken.substring(0, 20));

    // Store tokens
    window.localStorage.setItem("engrefresh", refreshToken);
    __WEBPACK_IMPORTED_MODULE_2_axios___default.a.defaults.headers.common["Authorization"] = "Bearer " + accessToken;

    console.log("Auth callback: Stored refresh token in localStorage");
    console.log("Auth callback: Set Authorization header");
    console.log("Auth callback: localStorage now contains:", localStorage.getItem("engrefresh") ? "refresh token" : "no refresh token");

    // Clean URL
    var url = new URL(window.location);
    url.searchParams.delete('access_token');
    url.searchParams.delete('refresh_token');
    window.history.replaceState({}, document.title, url.toString());

    console.log("Auth callback: Tokens stored successfully");
    return { success: true, accessToken: accessToken, refreshToken: refreshToken };
  }

  return { success: false, message: 'No tokens found' };
}

/***/ }),

/***/ 268:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(203)(
  /* script */
  __webpack_require__(269),
  /* template */
  __webpack_require__(270),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 269:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_authService__ = __webpack_require__(241);
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: "GoogleButton",
  methods: {
    redirect: function redirect() {
      window.location.href = "" + __WEBPACK_IMPORTED_MODULE_0__services_authService__["a" /* authService */].googleLogin;
    }
  }
});

/***/ }),

/***/ 270:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "id": "main"
    }
  }, [_c('button', {
    staticClass: "fullBtn",
    on: {
      "click": function($event) {
        return _vm.redirect()
      }
    }
  }, [_c('inline-svg', {
    staticClass: "googleIcon",
    attrs: {
      "src": __webpack_require__(212).default
    }
  }), _vm._v("\n    " + _vm._s(_vm.$t("user.loginButton.button")) + "\n  ")], 1)])
},staticRenderFns: []}

/***/ }),

/***/ 313:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/payment_logos.8cd978c.svg";

/***/ }),

/***/ 477:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(478);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(177)("19cb0f34", content, true, {});

/***/ }),

/***/ 478:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(176)(true);
// imports


// module
exports.push([module.i, "\n.monthp[data-v-cf7f3b7a] {\n  font-size: 12px;\n  font-weight: 400;\n}\n.prices[data-v-cf7f3b7a] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n}\n.footerLinks[data-v-cf7f3b7a] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n  margin-top: auto;\n  margin-bottom: 32px;\n}\n", "", {"version":3,"sources":["/__w/lang_app_eng/lang_app_eng/src/components/Registration/registration.vue"],"names":[],"mappings":";AACA;EACE,gBAAgB;EAChB,iBAAiB;CAClB;AACD;EACE,qBAAqB;EACrB,qBAAqB;EACrB,cAAc;EACd,6BAA6B;EAC7B,8BAA8B;MAC1B,2BAA2B;UACvB,uBAAuB;CAChC;AACD;EACE,qBAAqB;EACrB,qBAAqB;EACrB,cAAc;EACd,0BAA0B;MACtB,uBAAuB;UACnB,+BAA+B;EACvC,iBAAiB;EACjB,oBAAoB;CACrB","file":"registration.vue","sourcesContent":["\n.monthp[data-v-cf7f3b7a] {\n  font-size: 12px;\n  font-weight: 400;\n}\n.prices[data-v-cf7f3b7a] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n}\n.footerLinks[data-v-cf7f3b7a] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n  margin-top: auto;\n  margin-bottom: 32px;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 479:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Shared_VideoPlayer_vue__ = __webpack_require__(204);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Shared_VideoPlayer_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Shared_VideoPlayer_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__User_googleButton_vue__ = __webpack_require__(268);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__User_googleButton_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__User_googleButton_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__registration_scss__ = __webpack_require__(480);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__registration_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__registration_scss__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      chosenPayment: 1,
      htmlModal: "",
      isLoading: false,
      ltr: localStorage.getItem("srcDirection") == "ltr"
    };
  },

  computed: {
    user: function user() {
      return this.$store.getters.user;
    },
    payment_options: function payment_options() {
      return this.$store.getters.payment_options;
    }
  },
  watch: {
    payment_options: function (_payment_options) {
      function payment_options() {
        return _payment_options.apply(this, arguments);
      }

      payment_options.toString = function () {
        return _payment_options.toString();
      };

      return payment_options;
    }(function () {
      if (this.payment_options.length) this.chosenPayment = payment_options.find(option.recommended) || 1;
    })
  },
  mounted: function mounted() {
    if (this.payment_options.length) this.chosenPayment = 1;
  },

  methods: {
    getSelectedPlanCycle: function getSelectedPlanCycle() {
      var selectedPlanCycle = this.payment_options[this.chosenPayment - 1].months;
      return this.$t("registration.registration.months." + selectedPlanCycle);
    },
    goPay: function goPay() {
      if (this.chosenPayment) {
        this.$router.push({
          path: "/payment/" + this.payment_options[this.chosenPayment - 1].id
        });
      }
    },
    goBack: function goBack() {
      this.$router.push('/');
    },
    navigate: function navigate(path) {
      this.$router.push("/" + path);
    },
    goToWA: function goToWA() {
      //console.log("YO");
      window.open("https://api.whatsapp.com/send?phone=972526252650&text=%D7%94%D7%99%D7%99!%20%F0%9F%98%83%0A%D7%90%D7%A0%D7%99%20%D7%A8%D7%9B%D7%A9%D7%AA%D7%99%20%D7%9E%D7%A0%D7%95%D7%99%20%D7%9C%D7%90%D7%A4%D7%9C%D7%99%D7%A7%D7%A6%D7%99%D7%94%20%D7%A9%D7%9C%D7%9A%20%D7%9B%D7%91%D7%A8%20%D7%95%D7%92%D7%9D%20%D7%99%D7%A9%20%D7%9C%D7%99%20%D7%A7%D7%91%D7%9C%D7%94%20%D7%90%D7%91%D7%9C%20%D7%96%D7%94%20%D7%93%D7%95%D7%A8%D7%A9%20%D7%9E%D7%9E%D7%A0%D7%99%20%D7%AA%D7%A9%D7%9C%D7%95%D7%9D%2C%20%D7%AA%D7%95%D7%9B%D7%9C%20%D7%9C%D7%A2%D7%96%D7%95%D7%A8%20%D7%9C%D7%99%20%D7%9C%D7%A9%D7%97%D7%96%D7%A8%20%D7%90%D7%AA%20%D7%94%D7%9E%D7%A0%D7%95%D7%99%20%D7%A9%D7%9C%D7%99%3F%0A%D7%AA%D7%95%D7%93%D7%94", "_blank");
    }
  },
  components: {
    VideoPlayer: __WEBPACK_IMPORTED_MODULE_0__components_Shared_VideoPlayer_vue___default.a,
    GoogleButton: __WEBPACK_IMPORTED_MODULE_1__User_googleButton_vue___default.a
  }
});

/***/ }),

/***/ 480:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(481);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(177)("38b3a574", content, true, {});

/***/ }),

/***/ 481:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(176)(true);
// imports


// module
exports.push([module.i, ".registration{padding:20px;position:absolute;inset:0;display:flex;flex-direction:column}.registration h2{font:var(--large-font);margin-top:10px}.registration svg{overflow:visible}.registration .subscriptions-loader{font:var(--small-font);display:flex;flex-direction:column;justify-content:center;align-items:center;gap:12px;position:fixed;inset:0;z-index:-1}.registration .lockbreak{width:25px}.registration .register-text{margin-top:44px;font:var(--large-font);margin-bottom:20px}.registration .package-details{font:var(--medium-font)}.registration .subtitle{font:var(--medium-font);margin-bottom:24px}.registration .icon{width:30px;padding-bottom:10px}.registration .line{display:flex;margin:10px 20px;align-items:center;gap:10px}.registration .program-option{height:fit-content;border:1px solid #000;font:var(--medium-font);border-radius:5px;display:flex;align-items:center;justify-content:space-between;margin:10px 0;padding:16px 28px}.registration .bestOption{position:relative;padding-top:20px}.registration .chosenOption{background-color:#555fff;color:#fff;outline:3px solid #119}.registration .footerLinks span{font:var(--small-font)}.registration .recomanded{background-color:#119;color:#fff;font:var(--tiny-font);position:absolute;top:0;padding:0px 10px}.registration .recommended-right{right:0px;border-bottom-left-radius:10px}.registration .recommended-left{left:0px;border-bottom-right-radius:10px}.registration .takanon{width:100%;background-color:#fff;border:#a6a6d9 1px solid;height:100px;overflow:scroll;margin:5px auto;padding:3px}.registration .takanon p{font:var(--small-font)}.registration .confirm{background-color:#fff;border:#a6a6d9 1px solid;height:100px;overflow:scroll;border-radius:5px;margin:70px auto 10px;padding:8px}.registration .confirm p{font:var(--small-font)}.registration .submit-payment{margin:48px 0;display:flex;justify-content:center;flex-direction:column}.registration .submit-payment button{width:100%;height:58px;border-radius:8px;background-color:#6465fe;color:#fff;margin:auto;font:var(--medium-font)}.registration .disclaimer-text{font:var(--tiny-font);padding:8px;text-align:justify;color:#555}.modal-container{position:fixed;z-index:1000;width:100%;left:0;top:0;background-color:rgba(0,0,0,.4);height:100%}.modal-content{background:#fff;height:fit-content;text-align:center;padding:5%;border-radius:5px;margin:30% 0}", "", {"version":3,"sources":["/__w/lang_app_eng/lang_app_eng/src/components/Registration/src/components/Registration/registration.scss"],"names":[],"mappings":"AAAA,cACE,aACA,kBACA,QACA,aACA,qBAAA,CACA,iBACE,uBACA,eAAA,CAEF,kBACE,gBAAA,CAEF,oCACE,uBACA,aACA,sBACA,uBACA,mBACA,SACA,eACA,QACA,UAAA,CAEF,yBACE,UAAA,CAEF,6BACE,gBACA,uBACA,kBAAA,CAEF,+BACE,uBAAA,CAEF,wBACE,wBACA,kBAAA,CAEF,oBACE,WACA,mBAAA,CAEF,oBACE,aACA,iBACA,mBACA,QAAA,CAEF,8BACE,mBACA,sBACA,wBACA,kBACA,aACA,mBACA,8BACA,cACA,iBAAA,CAEF,0BACE,kBACA,gBAAA,CAEF,4BACE,yBACA,WACA,sBAAA,CAEF,gCACE,sBAAA,CAEF,0BACE,sBACA,WACA,sBACA,kBACA,MACA,gBAAA,CAEF,iCACE,UACA,8BAAA,CAEF,gCACE,SACA,+BAAA,CAEF,uBACE,WACA,sBACA,yBACA,aACA,gBACA,gBACA,WAAA,CACA,yBACE,sBAAA,CAGJ,uBACE,sBACA,yBACA,aACA,gBACA,kBACA,sBACA,WAAA,CACA,yBACE,sBAAA,CAGJ,8BACE,cACA,aACA,uBACA,qBAAA,CACA,qCACE,WACA,YACA,kBACA,yBACA,WACA,YACA,uBAAA,CAGJ,+BACE,sBACA,YACA,mBACA,UAAA,CAIJ,iBACE,eACA,aACA,WACA,OACA,MACA,gCACA,WAAA,CAGF,eACE,gBACA,mBACA,kBACA,WACA,kBACA,YAAA,CAAA","file":"registration.scss","sourcesContent":[".registration {\n  padding: 20px;\n  position: absolute;\n  inset:0;\n  display: flex;\n  flex-direction: column;\n  h2 {\n    font: var(--large-font);\n    margin-top: 10px;\n  }\n  svg {\n    overflow: visible;\n  }\n  .subscriptions-loader{\n    font: var(--small-font);\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    gap: 12px;\n    position: fixed;\n    inset: 0;\n    z-index: -1;\n  }\n  .lockbreak {\n    width: 25px;\n  }\n  .register-text{\n    margin-top: 44px;\n    font: var(--large-font);\n    margin-bottom: 20px;\n  }\n  .package-details {\n    font: var(--medium-font);\n  }\n  .subtitle {\n    font: var(--medium-font);\n    margin-bottom: 24px;\n  }\n  .icon {\n    width: 30px;\n    padding-bottom: 10px;\n  }\n  .line {\n    display: flex;\n    margin: 10px 20px;\n    align-items: center;\n    gap: 10px;\n  }\n  .program-option {\n    height: fit-content;\n    border: 1px solid black;\n    font: var(--medium-font);\n    border-radius: 5px;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    margin: 10px 0;\n    padding: 16px 28px;\n  }\n  .bestOption {\n    position: relative;\n    padding-top: 20px;\n  }\n  .chosenOption {\n    background-color: #555fff;\n    color: #fff;\n    outline: 3px solid #111199;\n  }\n  .footerLinks span {\n    font: var(--small-font);\n  }\n  .recomanded {\n    background-color: #111199;\n    color: white;\n    font: var(--tiny-font);\n    position: absolute;\n    top: 0;\n    padding: 0px 10px;\n  }\n  .recommended-right {\n    right: 0px;\n    border-bottom-left-radius: 10px;\n  }\n  .recommended-left {\n    left: 0px;\n    border-bottom-right-radius: 10px;\n  }\n  .takanon {\n    width: 100%;\n    background-color: white;\n    border: #a6a6d9 1px solid;\n    height: 100px;\n    overflow: scroll;\n    margin: 5px auto;\n    padding: 3px;\n    p {\n      font: var(--small-font);\n    }\n  }\n  .confirm {\n    background-color: white;\n    border: #a6a6d9 1px solid;\n    height: 100px;\n    overflow: scroll;\n    border-radius: 5px;\n    margin: 70px auto 10px;\n    padding: 8px;\n    p {\n      font: var(--small-font);\n    }\n  }\n  .submit-payment {\n    margin: 48px 0;\n    display: flex;\n    justify-content: center;\n    flex-direction: column;\n    button {\n      width: 100%;\n      height: 58px;\n      border-radius: 8px;\n      background-color: rgb(100, 101, 254);\n      color: white;\n      margin: auto;\n      font: var(--medium-font);\n    }\n  }\n  .disclaimer-text {\n    font: var(--tiny-font);\n    padding: 8px;\n    text-align: justify;\n    color: #555;\n  }\n}\n\n.modal-container {\n  position: fixed;\n  z-index: 1000;\n  width: 100%;\n  left: 0;\n  top: 0;\n  background-color: rgba(0,0,0,0.4);\n  height: 100%;\n}\n\n.modal-content {\n  background: white;\n  height: fit-content;\n  text-align: center;\n  padding: 5%;\n  border-radius: 5px;\n  margin: 30% 0;\n}"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 482:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "registration"
  }, [_c('inline-svg', {
    attrs: {
      "src": __webpack_require__(483).default
    },
    on: {
      "click": _vm.goBack
    }
  }), _vm._v(" "), _c('h2', [_vm._v("\n    " + _vm._s(_vm.$t("registration.registration.text1")) + "\n    "), _c('inline-svg', {
    staticClass: "lockbreak",
    attrs: {
      "src": __webpack_require__(484).default
    }
  })], 1), _vm._v(" "), (_vm.isLoading) ? _c('div', {
    staticClass: "modal-container",
    domProps: {
      "innerHTML": _vm._s(_vm.htmlModal)
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.user) ? _c('div', {
    staticClass: "register-text"
  }, [_vm._v("\n    " + _vm._s(_vm.$t("registration.registration.text1")) + "\n  ")]) : _vm._e(), _vm._v(" "), (!_vm.user) ? _c('div', [_c('GoogleButton')], 1) : _vm._e(), _vm._v(" "), (_vm.user) ? _c('div', {
    staticClass: "program-choose"
  }, [_c('p', {
    staticClass: "subtitle"
  }, [_vm._v(_vm._s(_vm.$t("registration.registration.text3")))]), _vm._v(" "), (!_vm.payment_options.length) ? _c('div', [_vm._v("\n      " + _vm._s(_vm.$t("registration.registration.loading")) + "\n      "), _c('v-progress-circular', {
    attrs: {
      "indeterminate": "",
      "color": "primary"
    }
  })], 1) : _vm._e(), _vm._v(" "), _vm._l((_vm.payment_options), function(option, idx) {
    return _c('div', {
      key: idx,
      staticClass: "program-option",
      class: {
        chosenOption: _vm.chosenPayment == idx + 1,
        bestOption: option.recommended
      },
      on: {
        "click": function($event) {
          _vm.chosenPayment = idx + 1
        }
      }
    }, [(option.recommended) ? _c('div', {
      staticClass: "recomanded",
      class: _vm.ltr ? 'recommended-left' : 'recommended-right'
    }, [_vm._v(_vm._s(_vm.$t("registration.registration.recommended")))]) : _vm._e(), _vm._v(" "), _c('span', [_vm._v(_vm._s(option.text))]), _vm._v(" "), _c('div', {
      staticClass: "prices"
    }, [_c('span', [_vm._v("\n          " + _vm._s(_vm.$t("registration.registration.sum")) + " ₪" + _vm._s(Math.round(option.price) * (option.recurring || 1)))]), _vm._v(" "), _c('span', {
      staticClass: "monthp"
    }, [_vm._v("₪" + _vm._s((Math.round(option.price) / (option.months || 1)).toFixed(1)) + "\n          " + _vm._s(_vm.$t("registration.registration.month")))])])])
  })], 2) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.user) ? _c('div', {
    staticClass: "submit-payment"
  }, [_c('button', {
    on: {
      "click": _vm.goPay
    }
  }, [_vm._v("\n      " + _vm._s(_vm.$t("registration.registration.payment")) + "\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "disclaimer-text"
  }, [_vm._v("\n      " + _vm._s(_vm.$t("registration.registration.disclaimer.part_1")) + " "), _c('strong', [_vm._v(_vm._s(_vm.$t("registration.registration.disclaimer.part_2")))]), _vm._v(". " + _vm._s(_vm.$t("registration.registration.disclaimer.part_3")) + "-" + _vm._s(new Date().toLocaleDateString('he-il')) + " " + _vm._s(_vm.$t("registration.registration.disclaimer.part_4")) + " " + _vm._s(_vm.getSelectedPlanCycle()) + ". " + _vm._s(_vm.$t("registration.registration.disclaimer.part_5")) + ".\n    ")])]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "footerLinks"
  }, [_c('span', {
    on: {
      "click": _vm.goToWA
    }
  }, [_vm._v(_vm._s(_vm.$t("registration.registration.text4")))]), _vm._v(" "), _c('span', {
    on: {
      "click": function($event) {
        return _vm.navigate('privacy')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("registration.registration.text5")))]), _vm._v(" "), _c('span', {
    on: {
      "click": function($event) {
        return _vm.navigate('terms')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("registration.registration.text6")))])]), _vm._v(" "), (_vm.user) ? _c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(313)
    }
  })]) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),

/***/ 483:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjIiIGhlaWdodD0iMjIiIHZpZXdCb3g9IjAgMCAyNyAyNyIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTEuNSAxLjVMMjUuNSAyNS41IiBzdHJva2U9IiM3MDcwNzAiIHN0cm9rZS13aWR0aD0iMyIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIi8+CjxwYXRoIGQ9Ik0yNS41IDEuNUwxLjUgMjUuNSIgc3Ryb2tlPSIjNzA3MDcwIiBzdHJva2Utd2lkdGg9IjMiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIvPgo8L3N2Zz4K");

/***/ }),

/***/ 484:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ("data:image/svg+xml;base64,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");

/***/ })

});


// WEBPACK FOOTER //
// 12.ce03fd3d81a126f24b18.bundle.js